export default __webpack_public_path__ + "static/rauw-c2e2fadc0700a3dc874fc00581482f14.jpg";